import { render, staticRenderFns } from "./WaybillEditRXJC.vue?vue&type=template&id=6c2a588d&scoped=true&"
import script from "./WaybillEditRXJC.vue?vue&type=script&lang=js&"
export * from "./WaybillEditRXJC.vue?vue&type=script&lang=js&"
import style0 from "./WaybillEditRXJC.vue?vue&type=style&index=0&id=6c2a588d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a588d",
  null
  
)

export default component.exports